export default defineAppConfig({
  ui: {
    colors: {
      // Axalta brand red as primary color
      primary: 'red',
      // Professional neutral grays for industrial look
      neutral: 'neutral',
    },
  },
})
